import React, { useContext } from 'react'
import styled from 'styled-components'
import { Flex, Hide, Link } from 'pcln-design-system'
import { themeGet } from '@styled-system/theme-get'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import {
  fireEventForViewMoreDeals,
  renderXSellProducts
} from '@/components/CrossSell/inventoryHelper'
import { Listing } from './types'
import { HeadingNonXL, HeadingXL } from './InventoryHeading'

const ViewMoreDeals = styled(Link)`
  font-size: 12px;
  font-weight: bold;
`

const ScrollContainer = styled(Flex)`
  overflow: auto hidden;
  & > :last-child {
    margin-right: ${themeGet('space.1')}px;
  }
`

export default function Inventory({
  xSellMessaging,
  xSellProduct,
  xSellUrl,
  listings,
  offerToken
}: {
  xSellMessaging: string
  xSellProduct: 'rental car' | 'flight' | 'hotel'
  xSellUrl: string
  listings: Listing[]
  offerToken: string
}) {
  const { isMobile = false } = useContext(BootstrapDataContext)

  const viewMoreDeals = ({ target }: { target?: string } = {}) => (
    <ViewMoreDeals
      onClick={fireEventForViewMoreDeals}
      href={xSellUrl}
      target={target}
      color="primary"
      variation="fill"
      py={2}
      px={3}
    >
      View more {xSellProduct} deals
    </ViewMoreDeals>
  )
  const renderedProducts = renderXSellProducts(
    listings,
    offerToken,
    isMobile ? 2 : 3
  )

  return (
    <>
      <Hide width={8 / 11} mt={40} ml={24} xs sm md lg>
        <HeadingXL xSellMessaging={xSellMessaging}>
          {viewMoreDeals({ target: '_blank' })}
        </HeadingXL>
        <ScrollContainer data-testid="inventory-list" mt={12}>
          {renderedProducts}
        </ScrollContainer>
      </Hide>
      <Hide
        width={[1, null, 2 / 3]}
        mt={[24, null, 3, 40]}
        ml={[0, null, null, 24]}
        mb={[0, null, null, 24]}
        xl
        xxl
      >
        <HeadingNonXL xSellMessaging={xSellMessaging}>
          {viewMoreDeals({ target: '_blank' })}
        </HeadingNonXL>
        <ScrollContainer
          mx={[-3, null, null, 0]}
          px={[3, null, null, 0]}
          mt={24}
        >
          {renderedProducts}
        </ScrollContainer>
      </Hide>
    </>
  )
}
